/* eslint-disable object-curly-newline */

export default {
	status: 422,
	data: {
		code: 422,
		message: 'height-minimum',
	},
};
